import { Dispatch, SetStateAction } from 'react'

export default (setEditMode: Dispatch<SetStateAction<boolean>>) => [
  {
    name: 'generic.edit',
    onClick: () => setEditMode(true),
  },
]
